import Maintenance from "@/views/admin/settings/Maintenance";

export default {
  path: "settings/maintenance",
  name: "settings-maintenance",
  component: Maintenance,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
